import {Tab, TabTypeData, TabTypes} from "./Tab";
import {actionAddTab} from "../store/tabs/actions";
import uuid = require("uuid");

export class TabsService {

	static createTab (title: string, type: TabTypes, item?: any, data?: any): Tab {
		let tab: Tab = {
			id: uuid.v4(),
			title: title,
			type: type,
			item: item,
			state: [],
			rang: null,
			data: data
		}
		actionAddTab(tab)
		return tab
	}
}
